import React from 'react'

const Manual = () => {
  return (
    <div style={{marginLeft:22}}>
        <h3>User Instruction For Using Application </h3>
        <div>
        <h4 style={{color:'red'}}>1.Condition for bed Shift</h4>

<p><strong>A.</strong>Guest should be not inNotice .</p>
<p><strong>B.</strong>Guest Must be clear all his previous due to shift .</p>
<p><strong>C.</strong>If guest is regular,then from shifting days his new rent will be applicable, and till when he stayed on previous bed ,after deducting rent from previous transaction rest amount will be added in his new rent if any otherwise due.</p>
<p><strong>D.</strong>There is no red color code for Monthly Guy Because from starting there was no such requirement of due Calculation for month .</p>
<p><strong>E.</strong>Bed Shifting is Available Only For Regular Active Guest.</p>
       </div>

      

       <div>
        <h4 style={{color:'red'}}>2.Condition for Updating Bed From Ac to NonAc & Vice Versa.</h4>
<p><strong>A.</strong>All Beds must be vacated of that room -<b>If Not</b>.</p>
<p><strong>B.</strong>No of sharing Must be same..</p>
<p><strong>C.</strong>Do not update only one Bed for particular room otherwise in Rentpackage  From data will be mismatched.</p>
<p><strong>D.</strong>In a room All beds may be either Ac or NonAc.</p>
<p><strong>E.</strong>Default Rent Must be Filled While changing Status of Bed If there is Guest  On that Bed.</p>
       </div>

       <div>
        <h4 style={{color:'red'}}>Force CheckOut Reason</h4>
        <p><strong>A.</strong>Please give a valid Reason if you are Checking Out Guest with Positive Due -</p>
       </div>
       <div>
        <h4 style={{color:'red'}}>Downlaod Transaction </h4>
        <p><strong>A.</strong>Go to Download Transaction Page-</p>
        <p><strong>B.</strong>Select the building you want to download Transaction for.</p>
        <p><strong>C.</strong>Select Start Date and Ending date you want download transaction for.</p>
        <p><strong>D.</strong>Click on Download Button</p>
       </div>
     
    </div>
  )
}

export default Manual